import type { GuestIn } from '@shared/types'

export function dollarsToMinorUnits(value: number | string): number {
	const amount = typeof value === 'number' ? value : Number.parseFloat(value)
	return Number.isFinite(amount) ? Math.round(Math.max(0, amount) * 100) : 0
}

export function createEmptyGuest(): GuestIn {
	return { first_name: '', last_name: '', email: '', phone: '' }
}

export function normalizeGuests(guests: GuestIn[]): GuestIn[] {
	return guests.map(guest => ({
		first_name: guest.first_name?.trim(),
		last_name: guest.last_name?.trim(),
		email: guest.email?.trim(),
		phone: guest.phone?.trim(),
	}))
}

export function guestsAreValid(guests: GuestIn[]): boolean {
	return guests.every(guest => (guest.first_name?.trim().length ?? 0) > 0 && (guest.last_name?.trim().length ?? 0) > 0)
}
